import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['input']

  switch(event) {
    this.inputTarget.value = event.currentTarget.checked ? 'realtime' : 'disabled'
  }
}
